export default __webpack_public_path__ + "static/media/BG_Page_04.97677154.svg";